import React, { useEffect } from "react";

import TransactionTicket from "pages/_components/TransactionTicket";
import CreateEcheqRuleTransactionData from "pages/v2/echeq/CreateEcheqRuleTransactionData";
import { actions, selectors as echeqRuleSelectors } from "reducers/echeqRule";
import { push, goBack } from "react-router-redux";
import { actions as formActions } from "reducers/form";
import { func, shape, bool } from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import { resizableRoute } from "pages/_components/Resizable";
import * as i18n from "util/i18n";

const CreateEcheqRuleTransaction = (props) => {
    const {
        transactionData,
        isDesktop,
        fetching,
        isSmallDesktop,
        dispatch,
        goBackEcheqsRule,
        history,
        embeddedInV3Shell,
    } = props;
    const summaryDataComponent = () => <CreateEcheqRuleTransactionData />;

    const signTransaction = () => {
        const signTransactionData = summaryDataComponent();

        dispatch(push("/transactions/sign"));
        dispatch(
            formActions.signTransactionData({
                idTransaction: transactionData?.idTransaction,
                idActivity: transactionData?.idActivity,
                idForm: "",
                content: signTransactionData,
                title: `manage.echeq.rules.${transactionData.data.actionType}.summary.title`,
                pendingDispatch: transactionData?.pendingDispatch,
            }),
        );

        dispatch(
            formActions.signTransactionPreview({
                idActivity: transactionData?.idActivity,
                idTransaction: transactionData?.idTransaction,
                idForm: "",
                ticketData: transactionData,
            }),
        );
    };

    const buttonsDetail = () => [
        {
            label: "manage.echeq.rules.button.goToList",
            bsStyle: "primary",
            onClick: () => dispatch(push("/v2/echeqRules")),
        },
    ];
    const haveTransactionPage = (path) => {
        const pattern1 = /.*\/transaction\/[A-Za-z0-9]*/;
        return pattern1.test(path);
    };

    const fixPath = async () => {
        const unlisten = await history?.listen((location) => {
            const nextPath = location?.pathname;

            if (haveTransactionPage(nextPath)) {
                dispatch(goBack());
            }
            unlisten();
        });
    };

    const handleBack = () => {
        if (goBackEcheqsRule) {
            dispatch(push("/v2/echeqRules"));
        } else {
            fixPath();
            dispatch(goBack());
        }
    };
    useEffect(() => {
        if (!transactionData?.idTransaction) {
            dispatch(goBack());
        }

        // El array de dependencia vacia garantiza que este efecto se ejecute solo una vez al desmontar.
        return () => {
            dispatch(actions.setGoBackEcheqsRule(false));
        };
    }, []);
    const creatorFullName =
        transactionData?.creatorFullName ||
        `${transactionData.userCreatorLastName}, ${transactionData.userCreatorFirstName}`;

    const centerContentMobile = () => (
        <div className="title-account-header-multiline-background-blue">
            <h1 style={{ width: "100%", marginTop: "2px" }}>
                {i18n.get(`manage.echeq.rules.${transactionData.data.actionType}.summary.title`)}
            </h1>
        </div>
    );

    return (
        <>
            {transactionData?.idTransaction && (
                <TransactionTicket
                    notificationScope="echeqsRule"
                    embeddedInV3Shell={embeddedInV3Shell}
                    embeddedV3GoBackPath="/v2/echeqRules"
                    handleBack={handleBack}
                    rightContent={transactionData?.idTransactionStatus === "PENDING" && null}
                    emptyRightOption={
                        (isDesktop && transactionData?.idTransactionStatus !== "FINISHED") ||
                        (!isDesktop &&
                            transactionData?.idTransactionStatus !== "PENDING" &&
                            transactionData?.idTransactionStatus !== "FINISHED")
                    }
                    headerClassName={!isDesktop ? "blue-main-header-mobile blue-main-title-mobile" : ""}
                    hasInlineButtons
                    hideMobileMenu={!isDesktop}
                    fetching={fetching}
                    summary={{ ...transactionData, creatorFullName }}
                    centerElement={isDesktop ? undefined : centerContentMobile}
                    buttonsDetail={buttonsDetail()}
                    isDesktop={isDesktop}
                    isSmallDesktop={isSmallDesktop}
                    onSignTicket={signTransaction}
                    ignoreHomeButton
                    summaryTitle={`manage.echeq.rules.${transactionData.data.actionType}.summary.title`}
                    isFetchingExport={false}>
                    <CreateEcheqRuleTransactionData isDesktop={isDesktop} />
                </TransactionTicket>
            )}
        </>
    );
};

CreateEcheqRuleTransaction.propTypes = {
    transactionData: shape({}).isRequired,
    fetching: bool.isRequired,
    isDesktop: bool.isRequired,
    isSmallDesktop: bool.isRequired,
    dispatch: func.isRequired,
    goBackEcheqsRule: bool.isRequired,
    history: shape({
        listen: func.isRequired,
    }).isRequired,
    embeddedInV3Shell: bool,
};
CreateEcheqRuleTransaction.defaultProps = {
    embeddedInV3Shell: false,
};

const mapStateToProps = (state) => ({
    transactionData: echeqRuleSelectors.getEcheqRuleTransactionData(state),
    goBackEcheqsRule: echeqRuleSelectors.isGoBackEcheqsRule(state),
    fetching: false,
});

export default compose(connect(mapStateToProps), resizableRoute)(CreateEcheqRuleTransaction);
